import API from "@utils/request";
import { PAGE_SIZE } from "@config";

const USER = "/user";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
  prout = 'protal';
} else {
  prout = 'protal_' + Language;
}

/**
 * 会员登录
 * @param {object} params
 */
export async function login(params) {
  try {
    return await API.post(USER + "login", params);
  } catch (error) {
    return error;
  }
}
/**
 * 登录/自动注册/验证码登录
 * @param {object} params
 */
export async function loginNew(params) {
  try {
      return await API.post("/api/" + prout + "/api/login/loginNew", params);
  } catch (error) {
    return error;
  }
}
/**
 * 找回密码
 * @param {object} params
 */
export async function forgot(params) {
  try {
    return await API.post("/api/" + prout + "/api/login/forgot", params);
  } catch (error) {
    return error;
  }
}
/**
 * 获取第一次完善信息界面
 * @param {object} params
 */
export async function userFirstEditView(params) {
  try {
      return await API.post("/api/" + prout + "/api/login/userFirstEditView", params);
  } catch (error) {
    return error;
  }
}
/**
 * 首次编辑用户信息
 * @param {object} params
 */
export async function user_first_edit(params) {
  try {
    return await API.post("/api/" + prout + "/api/login/user_first_edit", params);
  } catch (error) {
    return error;
  }
}
/**
 * 隐私声明 、用户注册协议
 * @param {object} params
 */
export async function userPriRegInfo(params) {
  try {
    return await API.post("/api/" + prout + "/api/login/userPriRegInfo", params);
  } catch (error) {
    return error;
  }
}

/**
 * 获取用户列表（分页）
 * @param {object} params
 * @param {object} pages
 */
export async function getUserList(
  params,
  pages = {
    pageindex: 1,
    pagesize: PAGE_SIZE,
  }
) {
  try {
    return await API.get(USER + "getuserList", {
      params: {
        ...params,
        ...pages,
      },
      headers: { isLoading: true },
    });
  } catch (error) {
    return error;
  }
}

/**
 * 获取用户详情
 * @param {number} id
 */
export async function getUserInfo(id) {
  try {
    return await API.get(USER + "getmemberfobyid", {
      params: {
        id,
      },
    });
  } catch (error) {
    return error;
  }
}

// 用户反馈



/**
 * 获取用户权限
 */
export async function getUserPermission() {
  // try {
  //   return await API.get(USER + "permission", {
  //     params: {
  //       id,
  //     },
  //   });
  // } catch (error) {
  //   return error;
  // }

  // 以下数据为，模拟接口返回权限数据格式
  return {
    code: '000000',
    data: [
      {
        id: 1,
        name: 'LOGIN',  // 前端路由名称
        path: '/logint', // 前端路由地址
        permission: ['add', 'del'] // 按钮权限
      }, {
        id: 2, // id
        name: 'USER',  // 前端路由名称
        path: '/user',  // 前端路由地址
      },
      {
        id: 3,
        name: 'USER_LIST',  // 前端路由名称
        path: '/user/list', // 前端路由地址
        permission: ['add', 'edit'] // 按钮权限
      },
      {
        id: 4,
        name: 'USER_EDIT',  // 前端路由名称
        path: '/user/edit', // 前端路由地址
        permission: ['add', 'edit'] // 按钮权限
      }
    ]
  }
}

export async function activityLoginInfo(params) {
  try {
    return await API.post("/api/" + prout +  "/api/login/activityLoginInfo", params);
  } catch (error) {
    return error;
  }
}
export async function activitySignUp(params) {
  try {
    return await API.post("/api/" + prout +  "/api/login/activityLoginInfo", params);
  } catch (error) {
    return error;
  }
}
export async function getSmsCaptcha(params) {
  try {
    return await API.post("/api/" +prout + "/tool/get_sms_captcha", params);
  } catch (error) {
    return error;
  }
}

export async function getEmailCode(params) {
  try {
    return await API.post("/api/" +prout + "/protal/tool/get_email_code", params);
  } catch (error) {
    return error;
  }
}
export async function getSmsCaptchaNew(params) {
  try {
    return await API.post("/api/" +prout + "/tool/get_sms_captcha_new", params);
  } catch (error) {
    return error;
  }
}

export async function getEmailCodeNew(params) {
  try {
    return await API.post("/api/" +prout + "/tool/get_email_code_new", params);
  } catch (error) {
    return error;
  }
}
export async function getDistrict(type,value) {
  try {
    return await API.get("/protal/usercenter/get_district", {
      params: {
        type,value,
      },
    });
  } catch (error) {
    return error;
  }
}
export async function hasModulePermission(params) {
  try {
    return await API.post("/api/" + prout + "/api/user/hasModulePermission", params);
  } catch (error) {
    return error;
  }
}

export async function hasModulePermissions(params) {
  try {
    return await API.post("/api/" + prout + "/api/user/hasModulePermissions", params);
  } catch (error) {
    return error;
  }
}
export async function activitySignUpLogin(params) {
  try {
    return await API.post("/api/" + prout +  "/api/login/login", params);
  } catch (error) {
    return error;
  }
}
export async function activitySignUpRegister(params) {
  try {
    return await API.post("/api/" + prout +  "/api/login/activityRegister", params);
  } catch (error) {
    return error;
  }
}
export async function isCheckCode(params) {
  try {
    return await API.post("/api/" + prout + "/api/login/isCheckCode", params);
  } catch (error) {
    return error;
  }
}
export async function activitySignUpReLoginEdit(params) {
  try {
    return await API.post("/api/" + prout +  "/api/login/activitySignUpReLoginEdit", params);
  } catch (error) {
    return error;
  }
}

export async function activitySignUpRegisters(params) {
  try {
    return await API.post("/api/" + prout +  "/api/login/activitySignUpRegister", params);
  } catch (error) {
    return error;
  }
}




/**
 *  图形拖动验证码-位置信息    drag_captcha/generateCaptcha
 * **/


export async function getactivitySignUpRegister(params) {
  try {
    return await API.post("/api/" + prout +  "/api/drag_captcha/generateCaptcha", params);
  } catch (error) {
    return error;
  }
}


/**
 *图形拖动验证码-验证 drag_captcha/verifyCaptcha
 * ***/ 

 export async function setverifyCaptcha(params) {
  try {
    return await API.post("/api/" + prout +  "/api/drag_captcha/verifyCaptcha", params);
  } catch (error) {
    return error;
  }
}

export async function updateXiaohaiStatus(params) {
  try {
    return await API.post("/api/" + prout + "/api/user/updateXiaohaiStatus", params);
  } catch (error) {
    return error;
  }
}
